export default "__VITE_ASSET__DoCM5QPn__"